module.exports = __webpack_public_path__ + "static/media/message-unread.00341692.svg";